import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram, Facebook } from 'lucide-react';
import { SITE } from '../mock/data';
import { publicApi } from '../api';

export default function Footer() {
  // Cities are read from the DB so newly-created cities appear in the footer
  // automatically (same pattern as Header). `coming_soon` cities are hidden.
  const [cities, setCities] = useState([]);
  useEffect(() => {
    let alive = true;
    publicApi.cities()
      .then(list => {
        if (!alive) return;
        setCities(
          (list || [])
            .filter(c => c && c.slug && c.status !== 'coming_soon')
            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
        );
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <footer className="bg-black text-white/90 mt-0 border-t border-[color:var(--yup-primary)]">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <img src={SITE.logo} alt="YUP" className="h-14 w-auto mb-3" />
          <p className="text-sm text-white/70 leading-relaxed">
            Your Utility Points — la tua guida turistica digitale.
          </p>
        </div>
        <div>
          <h4 className="font-semibold uppercase tracking-wider text-sm mb-4 text-[color:var(--yup-primary)]">Città</h4>
          <ul className="space-y-2 text-sm text-white/80">
            {cities.map(c => (
              <li key={c.slug}>
                <Link to={`/${c.slug}`} className="hover:text-white" data-testid={`footer-city-${c.slug}`}>
                  {c.name || c.slug}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-semibold uppercase tracking-wider text-sm mb-4 text-[color:var(--yup-primary)]">Info</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/cookie-policy" className="hover:text-white" data-testid="footer-cookie-link">Cookie Policy</Link></li>
            <li><Link to="/promuoviti" className="hover:text-white" data-testid="footer-promote-link">Promuovi la tua attività</Link></li>
            <li>
              <button
                onClick={() => window.__yupOpenCookiePrefs && window.__yupOpenCookiePrefs()}
                className="hover:text-white text-left"
                data-testid="footer-cookie-prefs-btn"
              >
                Preferenze Cookie
              </button>
            </li>
            <li>Termini &amp; Condizioni</li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold uppercase tracking-wider text-sm mb-4 text-[color:var(--yup-primary)]">Contatti</h4>
          <div className="flex items-center gap-2 text-sm text-white/80 mb-3">
            <Mail size={16} />
            <span>{SITE.contactEmail}</span>
          </div>
          <div className="flex items-center gap-3">
            <a href="#" aria-label="Instagram" className="p-2 bg-white/10 hover:bg-white/20 rounded-full transition">
              <Instagram size={18} />
            </a>
            <a href="#" aria-label="Facebook" className="p-2 bg-white/10 hover:bg-white/20 rounded-full transition">
              <Facebook size={18} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/60">
        © {new Date().getFullYear()} YUP – Your Utility Points. All rights reserved.
      </div>
    </footer>
  );
}
